<!-- 查询电表/水表/ -->
<template>
  <el-dialog
    :title="chooseType == 'electricity' ? '查询电表' : '查询水表'"
    :visible.sync="templeShowDialog"
    width="60%"
    style="height:500px,max-height:500px;"
    center
    :append-to-body="true"
    @closed="closeDialog"
  >
    <div class="page">
      <!-- <SiruiSearch
        ref="baseInfoFormRef"
        :query="params"
        :columns="chooseType == 'electricity' ? electricity : water"
        :rules="formRules"
        :isQueryPanel="true"
        :colSpan="8"
        :buttonSpan="5"
        @resetBtnClick="resetBtnClick"
        @searchBtnClick="searchBtnClick"
      ></SiruiSearch> -->
      <SiruiModalSearch
        ref="siruiModalSearch"
        :query="params"
        :columns="chooseType == 'electricity' ? electricity : water"
        @resetBtnClick="resetBtnClick"
        @searchBtnClick="searchBtnClick"
      ></SiruiModalSearch>
      <!-- <sirui-table
        v-if="chooseTelectricityype == 'electricity'"
        ref="electricityTable"
        style="max-height:200px,height:200px"
        :buttonList="menuButtonList"
        :loading="load"
        :data="tableData"
        :paging="true"
        :setting="false"
        :customVisible="false"
        :columns="columnListDefault"
        :showToolbar="true"
        :valid-config="{ autoPos: true, message: 'inline' }"
        @handleSizeChange="handleSizeChange"
        @handleCurrentChange="handleCurrentChange"
        @handleSelectionChange="handleSelectionChange"
      >
        <vxe-table-column
          v-for="(item, index) in columnListDefault"
          :key="index"
          :fixed="item.fixed"
          :sortable="item.sortable"
          :field="item.field"
          :title="item.title ? $t(item.title) : null"
          :visible="item.visible"
          :type="item.type"
          :width="item.width"
        >
          <template v-slot="{ row }">
            <template v-if="item.field === 'meterType'">
              {{ getStateLabel(row.meterType, 'meter_type') }}
            </template>
            <template v-else-if="item.field === 'effectiveStatus'"
              ><div>
                {{ getStateLabel(row.meterType, 'meter_status') }}
              </div></template
            >
            <template v-else>{{ row[item.field] }}</template>
          </template>
        </vxe-table-column>
        </sirui-table> -->

      <div v-if="chooseType == 'electricity'" style="">
        <vxe-table
          ref="xTable"
          :data="tableData"
          border
          max-height="430px"
          min-height="230px"
          show-overflow
          @select-change="handleSelectionChange"
          @select-all="handleSelectionChange"
          align="center"
          header-align="center"
        >
          <vxe-table-column type="checkbox" width="60"></vxe-table-column>
          <vxe-table-column field="meterNo" title="电表编号"></vxe-table-column>
          <vxe-table-column field="meterType" title="电表类型">
            <template v-slot="{ row }">
              <div>
                {{ getStateLabel(row.meterType, 'meter_type') }}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="transformer" title="变压器"></vxe-table-column>
          <vxe-table-column field="line" title="线路"></vxe-table-column>
          <vxe-table-column field="areaName" title="区域"></vxe-table-column>
          <vxe-table-column field="effectiveStatus" title="生效状态">
            <template v-slot="{ row }">
              <div>
                {{ getStateLabel(row.effectiveStatus, 'meter_status') }}
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
      <div v-else style="">
        <vxe-table
          ref="water_xTable"
          :data="tableData"
          max-height="430px"
          min-height="230px"
          border
          align="center"
          header-align="center"
          show-overflow
          @select-change="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <vxe-table-column type="checkbox" width="60"></vxe-table-column>
          <vxe-table-column field="meterNo" title="水表编号"></vxe-table-column>
          <vxe-table-column field="meterType" title="水表类型">
            <template v-slot="{ row }">
              <div>
                {{ getStateLabel(row.meterType, 'water_meter_type') }}
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column field="spaceName" title="片区"></vxe-table-column>
          <vxe-table-column field="unitName" title="单元名称"></vxe-table-column>
          <vxe-table-column field="floorName" title="楼层"></vxe-table-column>
          <vxe-table-column field="effectiveStatus" title="生效状态">
            <template v-slot="{ row }">
              <div>
                {{ getStateLabel(row.effectiveStatus, 'meter_status') }}
              </div>
            </template>
          </vxe-table-column>
        </vxe-table>
      </div>
    </div>

    <div class="bottom">
      <el-button type="primary" @click="closeDialog" :loading="load" class="btn-cancer"
        >取消</el-button
      >
      <el-button
        type="primary"
        @click="save"
        :loading="load"
        class="btn-save"
        :disabled="saveDisabled"
        >确认选择</el-button
      >
    </div>
  </el-dialog>
</template>
<script>
  // import SiruiSearch from '@/components/SiruiSearch';
  import SiruiModalSearch from '@/components/SiruiModalSearch';
  import API from '@/api/property/spaceAssets';
  import translateMinxin from '../../mixin/translateMinxin';
  export default {
    name: 'QueryTableDialog',
    mixins: [translateMinxin],
    components: {
      // SiruiSearch,
      SiruiModalSearch,
    },
    props: {
      showDialog: {
        type: Boolean,
        default: false,
      },
      form: {
        type: Object,
        default: () => {
          return {};
        },
      },
      companyCode: {
        type: String,
        default: '',
      },
      chooseType: {
        type: String,
        default: '',
      },
      chooseEnergyIds: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      electricity() {
        return [
          {
            prop: 'meterNo',
            name: '电表编号',
            type: 'input',
            placeholder: '请输入电表编号',
            span: 8,
          },
          {
            prop: 'meterType',
            name: '电表类型',
            type: 'select',
            placeholder: '请选择电表类型',
            options: [{ label: '全部', value: '' }, ...this.dictListMap['meter_type']],
            relatedColumn: 'none',
            clearable: true,
            span: 8,
          },
        ];
      },
      water() {
        return [
          {
            prop: 'meterNo',
            name: '水表编号',
            type: 'input',
            placeholder: '请输入水表编号',
            span: 8,
          },
          {
            prop: 'meterType',
            name: '水表类型',
            type: 'select',
            placeholder: '请选择水表类型',
            options: [{ label: '全部', value: '' }, ...this.dictListMap['water_meter_type']],
            relatedColumn: 'none',
            clearable: true,
            span: 8,
          },
        ];
      },
    },

    watch: {
      showDialog(var1, var2) {
        this.templeShowDialog = var2;
        this.templeShowDialog = var1;
      },
      multipleSelection(var1, var2) {
        if (var1.data?.length > 0) {
          this.saveDisabled = false;
        }
        console.log('改变了', var1, var2);
      },
    },
    data() {
      return {
        tableData: [],
        menuButtonList: [],
        saveDisabled: true,
        typeList: [{ value: 0, label: '全部' }],
        templeShowDialog: this.showDialog,
        formRules: {
          instructionNo: [{ required: false, message: '请输入电表标号', trigger: 'change' }],
          instructionNo2: [{ required: false, message: '请选择电表类型', trigger: 'change' }],
        },
        load: false,
        multipleSelection: [],
        params: {
          auditStatus: '',
          companyCode: '',
          effectiveStatus: '2',
          pageNum: 1,
          meterType: '',
          meterNo: '',
          pageSize: 10,
          associateSpace: false,
        },
        columnListDefault: [
          {
            type: 'checkbox',
            visible: true,
            width: '50',
            fixed: 'left',
          },
          {
            field: 'meterNo',
            title: '电表编号',
            visible: true,
          },
          {
            field: 'meterType',
            title: '电表类型',
            visible: true,
          },
          {
            field: 'transformer',
            title: '变压器',
            visible: true,
          },
          {
            field: 'line',
            title: '线路',
            visible: true,
          },
          {
            field: 'areaName',
            title: '区域',
            visible: true,
          },
          {
            field: 'effectiveStatus',
            title: '生效状态',
            visible: true,
          },
        ],
      };
    },
    mounted() {
      this.queryTableData();
    },

    methods: {
      closeDialog() {
        this.$emit('closeDialog', false);
      },
      save() {
        if (this.chooseType == 'electricity') {
          let selectRecords = this.$refs.xTable.getCheckboxRecords();
          if (selectRecords.length > 0) {
            let list = selectRecords.map((item) => {
              return {
                energyCode: item.meterNo,
                energyId: item.id,
                energyMeterType: item.meterType,
                energyMeterTypeName: this.getStateLabel(item.meterType, 'meter_type'),
                energyType: '02',
                energyTypeName: '电表',
              };
            });
            this.$emit('chooseData', list);
            this.closeDialog();
          }
        } else {
          let selectRecords = this.$refs.water_xTable.getCheckboxRecords();
          if (selectRecords.length > 0) {
            let list = selectRecords.map((item) => {
              return {
                energyCode: item.meterNo,
                energyId: item.id,
                energyMeterType: item.meterType,
                energyMeterTypeName: this.getStateLabel(item.meterType, 'water_meter_type'),
                energyType: '01',
                energyTypeName: '水表',
              };
            });
            this.$emit('chooseData', list);
            this.closeDialog();
          }
        }
      },
      //搜索
      searchBtnClick() {
        //this.$refs.electricityTable.setPageNum(1);
        //this.$refs.electricityTable.setPageSize(10);
        if (this.chooseType == 'electricity') {
          this.$refs.xTable.clearCheckboxReserve();
        } else {
          this.$refs.water_xTable.clearCheckboxReserve();
        }
        this.multipleSelection = [];
        this.queryTableData();
      },
      //重置
      resetBtnClick() {
        if (this.chooseType == 'electricity') {
          this.$refs.xTable.clearCheckboxReserve();
        } else {
          this.$refs.water_xTable.clearCheckboxReserve();
        }
        this.multipleSelection = [];
        // this.$refs.electricityTable.setPageNum(1);
        this.queryTableData();
      },
      //查询数据
      queryTableData(shouldInit) {
        // if (shouldInit) {
        //   const { pageNum, pageSize } = this.$refs.electricityTable.page;
        //   this.params.pageNum = pageNum;
        //   this.params.pageSize = pageSize;
        // }
        this.params.companyCode = this.companyCode;
        this.$axios
          .post(
            this.chooseType == 'electricity' ? API.ELECTRIC_METER_LIST2 : API.ELECTRIC_WATER_LIST,
            this.params
          )
          .then((res) => {
            if (shouldInit) {
              //  this.$refs.electricityTable.setPageNum(1);
              // this.$refs.electricityTable.setPageSize(10);
            }
            if (res.data.code == '0') {
              //this.$refs.electricityTable.setPageTotal(parseInt(res.data.data.total));
              //this.tableData = res.data.data.records;
              this.tableData = res.data.data;
              let chooseList = this.tableData.filter((item) =>
                this.chooseEnergyIds.includes(item.id)
              );
              if (chooseList.length > 0) {
                this.saveDisabled = false;
              }
              if (this.chooseType == 'electricity') {
                this.$refs.xTable.setCheckboxRow([...chooseList], true);
              } else {
                this.$refs.water_xTable.setCheckboxRow([...chooseList], true);
              }
            } else {
              this.$message.error(res.data.msg);
            }
          });
      },
      handleSizeChange() {
        this.queryTableData();
      },
      handleCurrentChange() {
        this.queryTableData();
      },
      handleSelectionChange(row) {
        this.multipleSelection = row;
      },
    },
  };
</script>
<style scoped lang="scss">
  .page {
    overflow: scroll;
    overflow-y: scroll;
    // height: calc(100vh - 295px);
  }

  .title {
    font-size: 14px;
    color: black;
    margin-left: 10px;
  }

  .fixed-bottom-btn {
    padding: 0px 0px;
    background-color: #e0e5ff;
    color: #597aff;
    min-width: 60px;
    height: 26px;
    border: 0px solid #dcdfe6;
  }

  .bottom {
    margin-top: 30px;
    text-align: center;

    .btn-cancer {
      padding: 0px 0px;
      background-color: #e0e5ff;
      color: #597aff;
      min-width: 80px;
      height: 30px;
      border: 0px solid #dcdfe6;
    }

    .btn-save {
      padding: 0px 0px;
      background-color: #66b1ff;
      color: white;
      min-width: 80px;
      height: 30px;
      margin-left: 20px;
      border: 0px solid #dcdfe6;
    }
  }

  // ::v-deep .el-dialog--center .el-dialog__body {
  //   padding: 25px 25px 0px;
  // }

  ::v-deep element.style {
    height: 200px;
  }
</style>
